// DTM
import React from "react";
import styled from "styled-components";

import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 1400px;
  margin: 0 calc(50% - 700px);
  float: left;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 1400px) {
    width: 100%;
    margin: 0;
  }
  @media (max-width: 1100px) {
    flex-wrap: wrap;
  }
`;

const Left = styled.div`
  width: 35%;
  margin: 50px 5% 50px 10%;
  @media (max-width: 1100px) {
    width: 90%;
    margin: 30px 5%;
  }
  @media (max-width: 700px) {
    width: calc(100% - 50px);
    margin: 20px 25px;
  }
`;
const Title = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 27px;
  font-weight: 900;
  letter-spacing: 0.4px;
  color: #3949ab;

  margin-top: 0.8em;
`;
const Subtitle = styled.div`
  width: 100%;

  font-family: Lato;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.85);

  text-transform: uppercase;

  margin-top: 0.8em;
`;
const Content = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 20px;
  letter-spacing: 0.3px;
  color: rgba(0, 0, 0, 0.85);

  margin-top: 0.3em;
`;
const Right = styled.div`
  width: 35%;
  margin: 50px 10% 50px 5%;
  @media (max-width: 1100px) {
    width: 90%;
    margin: 30px 5%;
  }
  @media (max-width: 700px) {
    width: calc(100% - 50px);
    margin: 20px 25px;
  }
`;

class Contact extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <Left>
          <Title>Van Zadelhoff Veilingen en Taxaties</Title>
          <Content>Nieuwe Havenweg 53A</Content>
          <Content>1216 BL Hilversum</Content>
          <Content>Nederland</Content>
          <Subtitle>Contact</Subtitle>
          <Content>035 624 71 70</Content>
          <Content>info@vanzadelhoff.nl</Content>
        </Left>
        <Right>
          <Subtitle>Openingstijden</Subtitle>
          <Content>dinsdag t/m zaterdag</Content>
          <Content>van 10:00 tot 12:00</Content>
          <Content>van 13:00 tot 16:00</Content>
          <Subtitle>Inbreng goederen</Subtitle>
          <Content>donderdag t/m zaterdag</Content>
          <Subtitle>Afhalen goederen</Subtitle>
          <Content>woensdag t/m zaterdag</Content>
        </Right>
      </Wrapper>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js